import { registerPlugin } from '@capacitor/core';

const WhatsAppStickers = registerPlugin('WhatsAppStickers', {
  web: () => import('./WhatsAppStickersWeb').then(m => new m.WhatsAppStickersWeb()),
});

export default WhatsAppStickers;
